/** Clé de cache de la vue portail (une seule requête alimente toute la page). */
export const PORTAL_QUERY_KEY = ['portal.view'] as const;
